import { connect } from "react-redux";
import EmpTicketsListing from "./empTicketsListing";
import { bindActionCreators } from "redux";
import { getTicketsList } from "services/redux/tickets/ticketsListing/action";
import { getStatusList } from "services/redux/tickets/ticketDetails/action";

const mapStateToProps = (state) => ({
    ticketsList: state.ticketsListingReducer.ticketsList,
    statusList: state.ticketDetailsReducer.statusList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getTicketsList,
        getStatusList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EmpTicketsListing);
